/**
 * @module common/containers/form_fields
 */
import React from 'react';
import { connect } from 'react-redux';
import { Field, submit } from 'redux-form';

/**
 * Reusable form field for redux form that handles submitting.
 * This main functionality is not being used now because of a bug in redux-form (when trying
 * to submit the form using action creators) but we should use that when it gets fixed.
 *
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 *
 * @returns {node} form field
 */
const RemoteSubmitField = ({ ...params }) => {
  const { classes, fieldName, fieldLabel, formName, disabled,
    component, options, dispatch, onChange, forms } = params;

  return (
    <Field
      classes={classes}
      name={fieldName}
      label={fieldLabel}
      component={component}
      options={options}
      disabled={disabled}
      customOnChange={(val) => {
        onChange(val);
      }}
    />
  );
};

const mapStateToProps = (state) => (
  {
    forms: state.form
  }
);

export default connect(mapStateToProps)(RemoteSubmitField);



// WEBPACK FOOTER //
// ./common/containers/form_fields.jsx